import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ILeaveBalance } from "../component/timeoff/leaves/leave-summary/leave-summary.types";
import { Document } from "../domains/models/document";

dayjs.extend(utc);
dayjs.extend(timezone);

const dateFormat = (date: any) => {
    if (date.length) return date;
    else return dayjs(date).format("YYYY-MM-DD");
}

const removeUnderScore = (value: any) => {
    if (typeof value !== "string") return value;
    return value.replace(/_/g, " ");
};


const remainingLeave = (leaveRes: ILeaveBalance) => {
    return (leaveRes.pending ?? 0) + (leaveRes.approved ?? 0);
};

const addUnderScoreWithUpperCase = (value: any) => {
    if (typeof value !== "string") return value;
    return value
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join("_");
};

const addUnderScoreWithUpper = (value: any) => {
    if (typeof value !== "string") return value;
    return value
        .split(" ")
        .map(word => word.toUpperCase())
        .join("_");
};

const firstCharUpperCase = (value: string) => {
    const stringArray = value.split(" ");
    let string: any = "";
    stringArray.forEach((item, index) => {
        if (index === 0) string = string + item.charAt(0).toUpperCase() + item.slice(1);
        else string = string + " " + item.charAt(0).toUpperCase() + item.slice(1);
    })
    return string;
}

const firstLetterUpperCase = (value: string | undefined) => {
    // For example - BIRTHDAY to Birthday
    if (!value || typeof value !== "string") return value;
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

const getShortDay = (dayName: string) => {
    if (!dayName) return '';
    return dayName.charAt(0).toUpperCase() + dayName.slice(1, 3).toLowerCase();
}

const capitalizeString = (tempString: string) => {
    const firstCharacter = tempString.charAt(0).toUpperCase();
    tempString = firstCharacter + tempString.slice(1).toLowerCase();
    return tempString;
}

const removeUnderScoreWithLowerCase = (value: any) => {
    if (typeof value !== "string") return value;
    let str = removeUnderScore(value);
    if (typeof str !== "string") return str;
    const parts = str.split("_").filter(Boolean);
    if (parts.length === 0) return str;
    return parts
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
};

function getGreeting(): string {
    const now = new Date();
    const hour = now.getHours();
    if (hour < 12) return "Good Morning";
    if (hour >= 12 && hour < 17) return "Good Afternoon";
    return "Good Evening";
}

const removeUnderScoreWithCaptialize = (designationCode: string) => {

    // For example - WORK_ANNIVERSARY to Work Anniversary
    return designationCode
        .toLowerCase()
        .replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

const replaceSpaceWithHyphen = (name: string) => {
    return name.trim().replace(/\s+/g, '-');
}

const pascalCase = (value: string) => {
    // to convert string with spaces to pascal format . ie. tom bridge => TomBridge
    const stringArray = value.search(/\s/) && value.split(/\s+/);
    let string: string = "";
    if (stringArray) {
        stringArray.forEach((item, index) => {
            if (index === 0) string = string + item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
            else string = string + item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
        })
    } else {
        string = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
    return string;
}

const camelCase = (value: string) => {
    // to convert string with spaces to camel format . ie. tom bridge => tomBridge
    const stringArray = value.search(/\s/) && value.split(/\s+/);
    let newStr: string = "";
    if (stringArray) {
        stringArray.forEach((item, index) => {
            if (index === 0) newStr = newStr + item.toLowerCase();
            else newStr = newStr + item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
        })
    } else {
        newStr = value.toLowerCase();
    }
    return newStr
}

const getINDTime = (time: string) => {
    if (!time) return dayjs();
    return dayjs.utc(time).tz("Asia/Kolkata");
};

const getTimeDiffInHHmm = (timeA: string, timeB?: string) => {
    if (!timeA) return "0m";
    const start = getINDTime(timeA);
    const end = timeB ? getINDTime(timeB) : dayjs();
    const diffInMinutes = end.diff(start, "minute");
    const hours = Math.floor(diffInMinutes / 60);
    const minutes = diffInMinutes % 60;
    return `${hours}h ${minutes}m`;
};

const formatTime = (time: string) => {
    if (!time) return "00:00";
    const d = getINDTime(time);
    let hour = d.hour();
    const minute = d.minute();
    const suffix = hour >= 12 ? "PM" : "AM";
    // Convert to 12-hour format
    hour = hour % 12;
    if (hour === 0) hour = 12;
    const minuteStr = minute.toString().padStart(2, "0");
    return `${hour}:${minuteStr} ${suffix}`;
}

const checkAdminWithEmployee = (user: any) => {
    return user.roles.includes("ADMIN") && user.roles.includes("EMPLOYEE");
}

const getIdfromApi = (response: any) => {
    return response.substring(response.lastIndexOf("/") + 1);
}

const getName = (firstName = '', middleName = '', lastName = '') => {
    const names = [firstName, middleName, lastName].map(n => n.trim()).filter(Boolean);
    // Capitalize first letter of each part
    const formattedNames = names.map(name => firstCharUpperCase(name));
    // Join with space
    return formattedNames.join(' ');
};

const parseDayFromDate = (date: Date) => {
    const tempDate = new Date(date)
    const day = tempDate.getDay()
    switch (day) {
        case 0: {
            return "SUNDAY"
        }
        case 1: {
            return "MONDAY"
        }
        case 2: {
            return "TUESDAY"
        }
        case 3: {
            return "WEDNESDAY"
        }
        case 4: {
            return "THURSDAY"
        }
        case 5: {
            return "FRIDAY"
        }
        case 6: {
            return "SATURDAY"
        }
    }
}

const isAgeGreaterThen18 = (dob: Date) => {
    const years = new Date().getFullYear() - dob.getFullYear()
    if (years > 18) return true
    if (years < 18) return false
    if (years === 18) {
        const months = new Date().getMonth() - dob.getMonth()
        if (months > 0) return true;
        if (months < 0) return false;
        if (months === 0) {
            const days = new Date().getDay() - dob.getDay()
            if (days > 0) return true;
            if (days < 0) return false;
        }
    }
}

function getDateFormat(date?: any) {
    return date ? new Date(date).toLocaleDateString("en-GB", {
            year: "numeric",
            month: "long",
            day: "numeric",
        }) :
        new Date().toLocaleDateString("en-GB", {
            year: "numeric",
            month: "long",
            day: "numeric",
        })
}

const getDateRange = (start: Date, end: Date): { date: string, day: string }[] => {
    const result = [];
    const current = new Date(start);
    while (current <= end) {
        result.push({
            date: current.toISOString().split("T")[0], // Format: YYYY-MM-DD
            day: parseDayFromDate(new Date(current))
        });
        current.setDate(current.getDate() + 1);
    }
    // @ts-ignore
    return result;
};

const getNumberOfDaysBetween = (start: string | Date, end: string | Date) => {
    const dateA = dayjs(start);
    const dateB = dayjs(end);
    return dateB.diff(dateA, 'days');
}

function formatToISODateOnly(input: string | number | Date | undefined | null): string | null {
    if (!input) return null;
    let date: Date;
    if (typeof input === "string" && /^\d{2}-\d{2}-\d{4}$/.test(input)) {
        const [month, day, year] = input.split("-");
        date = new Date(`${year}-${month}-${day}`);
    } else {
        date = new Date(input);
    }
    if (isNaN(date.getTime())) {
        console.error("Invalid date input:", input);
        return null;
    }
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

interface IUseLocalStorage {
    getItem: (key: string) => any | null;
    setItem: (key: string, value: any) => void;
    isPresent: (key: string) => boolean;
}

const useLocalStorage = (): IUseLocalStorage => {
    const getItem = (key: string) => {
        if (typeof window === "undefined") return null;
        const stored = localStorage.getItem(key);
        try {
            return stored ? JSON.parse(stored) : null;
        } catch (err) {
            console.error("Error parsing localStorage item", err);
            return null;
        }
    };

    const setItem = (key: string, value: any) => {
        if (typeof window === "undefined") return;
        localStorage.setItem(key, JSON.stringify(value));
    };

    const isPresent = (key: string): boolean => {
        if (typeof window === "undefined") return false;
        return localStorage.getItem(key) !== null;
    };
    return {getItem, setItem, isPresent};
};

function formatEnum(enumStr: string): string {
    return enumStr
        .toLowerCase()
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

const formatDateToDayMonth = (dateStr?: string) => {
    const d = dayjs(dateStr?.trim(), ["DD-MM-YYYY", "YYYY-MM-DD"], true);
    return d.isValid() ? d.format("DD MMMM") : "";
};

const getNameOnAvatar = (name: string) => {
    if (!name) return "";

    const words = name.trim().split(" ");

    if (words.length === 1) {
        return words[0][0].toUpperCase();
    }

    return (
        words[0][0] + words[words.length - 1][0]
    ).toUpperCase();
}


function getImageUrl(file: Document, size: 'small' | 'medium' | 'large' | 'original') {

    if (file.thumbnails) {
        switch (size) {
            case "small":
                return `${process.env.REACT_APP_API_CONTEXT}/v1/document/thumbnail/${file?.thumbnails.small.id}/content`
            case "medium":
                return `${process.env.REACT_APP_API_CONTEXT}/v1/document/thumbnail/${file?.thumbnails.medium.id}/content`
            case "large":
                return `${process.env.REACT_APP_API_CONTEXT}/v1/document/thumbnail/${file?.thumbnails.large.id}/content`
            case 'original':
                return `${process.env.REACT_APP_API_CONTEXT}/v1/document/${file?.id}/content`
        }
    } else {
        return `${process.env.REACT_APP_API_CONTEXT}/v1/document/${file?.id}/content`;
    }
}

export function getThumbnailUrl(thumbnailId?: string) {
    if (!thumbnailId) return null;
    return `${process.env.REACT_APP_API_CONTEXT}/v1/document/thumbnail/${thumbnailId}/content`;
}


const formatBloodGroup = (value: string) => {
    if (!value || typeof value !== "string") return value;

    return value
        .toLowerCase()
        .split("_")
        .map((word, index) => {
            if (index === 0) return word.toUpperCase(); // A
            return word.charAt(0).toUpperCase() + word.slice(1); // Negative
        })
        .join("-");
};

type Name = {
    firstName: string;
    middleName?: string;
    lastName?: string;
};

function getFullName(name: Name): string {
    const {firstName, middleName, lastName} = name;

    return [firstName, middleName, lastName]
        .filter(Boolean)
        .join(" ");
}

export {
    formatBloodGroup,
    getNameOnAvatar,
    dateFormat,
    removeUnderScore,
    firstCharUpperCase,
    addUnderScoreWithUpperCase,
    removeUnderScoreWithLowerCase,
    removeUnderScoreWithCaptialize,
    checkAdminWithEmployee,
    pascalCase,
    addUnderScoreWithUpper,
    getIdfromApi,
    getName,
    camelCase,
    getGreeting,
    parseDayFromDate,
    capitalizeString,
    isAgeGreaterThen18,
    getDateFormat,
    getDateRange,
    formatToISODateOnly,
    useLocalStorage,
    formatTime,
    formatEnum,
    getTimeDiffInHHmm,
    getNumberOfDaysBetween,
    remainingLeave,
    formatDateToDayMonth,
    getImageUrl,
    replaceSpaceWithHyphen,
    firstLetterUpperCase,
    getFullName,
    getShortDay
};
